/**
 * keen slider init
 */
 !(function (n, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((n =
        "undefined" != typeof globalThis ? globalThis : n || self).KeenSlider =
        t());
})(this, function () {
  "use strict";
  var n = function () {
    return (
      (n =
        Object.assign ||
        function (n) {
          for (var t, i = 1, e = arguments.length; i < e; i++)
            for (var r in (t = arguments[i]))
              Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          return n;
        }),
      n.apply(this, arguments)
    );
  };
  function t(n, t, i) {
    if (i || 2 === arguments.length)
      for (var e, r = 0, a = t.length; r < a; r++)
        (!e && r in t) ||
          (e || (e = Array.prototype.slice.call(t, 0, r)), (e[r] = t[r]));
    return n.concat(e || Array.prototype.slice.call(t));
  }
  function i(n) {
    return Array.prototype.slice.call(n);
  }
  function e(n, t) {
    var i = Math.floor(n);
    return i === t || i + 1 === t ? n : t;
  }
  function r() {
    return Date.now();
  }
  function a(n, t, i) {
    if (((t = "data-keen-slider-" + t), null === i))
      return n.removeAttribute(t);
    n.setAttribute(t, i || "");
  }
  function o(n, t) {
    return (
      (t = t || document),
      "function" == typeof n && (n = n(t)),
      Array.isArray(n)
        ? n
        : "string" == typeof n
        ? i(t.querySelectorAll(n))
        : n instanceof HTMLElement
        ? [n]
        : n instanceof NodeList
        ? i(n)
        : []
    );
  }
  function u(n) {
    n.raw && (n = n.raw),
      n.cancelable && !n.defaultPrevented && n.preventDefault();
  }
  function s(n) {
    n.raw && (n = n.raw), n.stopPropagation && n.stopPropagation();
  }
  function c() {
    var n = [];
    return {
      add: function (t, i, e, r) {
        t.addListener ? t.addListener(e) : t.addEventListener(i, e, r),
          n.push([t, i, e, r]);
      },
      input: function (n, t, i, e) {
        this.add(
          n,
          t,
          (function (n) {
            return function (t) {
              t.nativeEvent && (t = t.nativeEvent);
              var i = t.changedTouches || [],
                e = t.targetTouches || [],
                r = t.detail && t.detail.x ? t.detail : null;
              return n({
                id: r
                  ? r.identifier
                    ? r.identifier
                    : "i"
                  : e[0]
                  ? e[0]
                    ? e[0].identifier
                    : "e"
                  : "d",
                idChanged: r
                  ? r.identifier
                    ? r.identifier
                    : "i"
                  : i[0]
                  ? i[0]
                    ? i[0].identifier
                    : "e"
                  : "d",
                raw: t,
                x: r && r.x ? r.x : e[0] ? e[0].screenX : r ? r.x : t.pageX,
                y: r && r.y ? r.y : e[0] ? e[0].screenY : r ? r.y : t.pageY,
              });
            };
          })(i),
          e
        );
      },
      purge: function () {
        n.forEach(function (n) {
          n[0].removeListener
            ? n[0].removeListener(n[2])
            : n[0].removeEventListener(n[1], n[2], n[3]);
        }),
          (n = []);
      },
    };
  }
  function d(n, t, i) {
    return Math.min(Math.max(n, t), i);
  }
  function l(n) {
    return (n > 0 ? 1 : 0) - (n < 0 ? 1 : 0) || +n;
  }
  function f(n) {
    var t = n.getBoundingClientRect();
    return {
      height: e(t.height, n.offsetHeight),
      width: e(t.width, n.offsetWidth),
    };
  }
  function p(n, t, i, e) {
    var r = n && n[t];
    return null == r ? i : e && "function" == typeof r ? r() : r;
  }
  function v(n) {
    return Math.round(1e6 * n) / 1e6;
  }
  function h(n) {
    var t, i, e, r, a, o;
    function u(t) {
      o || (o = t), s(!0);
      var a = t - o;
      a > e && (a = e);
      var l = r[i];
      if (l[3] < a) return i++, u(t);
      var f = l[2],
        p = l[4],
        v = l[0],
        h = l[1] * (0, l[5])(0 === p ? 1 : (a - f) / p);
      if ((h && n.track.to(v + h), a < e)) return d();
      (o = null), s(!1), c(null), n.emit("animationEnded");
    }
    function s(n) {
      t.active = n;
    }
    function c(n) {
      t.targetIdx = n;
    }
    function d() {
      var n;
      (n = u), (a = window.requestAnimationFrame(n));
    }
    function l() {
      var t;
      (t = a),
        window.cancelAnimationFrame(t),
        s(!1),
        c(null),
        o && n.emit("animationStopped"),
        (o = null);
    }
    return (t = {
      active: !1,
      start: function (t) {
        if ((l(), n.track.details)) {
          var a = 0,
            o = n.track.details.position;
          (i = 0),
            (e = 0),
            (r = t.map(function (n) {
              var t,
                i = o,
                r = null !== (t = n.earlyExit) && void 0 !== t ? t : n.duration,
                u = n.easing,
                s = n.distance * u(r / n.duration) || 0;
              o += s;
              var c = e;
              return (e += r), (a += s), [i, n.distance, c, e, n.duration, u];
            })),
            c(n.track.distToIdx(a)),
            d(),
            n.emit("animationStarted");
        }
      },
      stop: l,
      targetIdx: null,
    });
  }
  function m(n) {
    var i,
      e,
      a,
      o,
      u,
      s,
      c,
      f,
      h,
      m,
      g,
      b,
      x,
      y,
      k = 1 / 0,
      w = [],
      M = null,
      T = 0;
    function C(n) {
      _(T + n);
    }
    function E(n) {
      var t = z(T + n).abs;
      return D(t) ? t : null;
    }
    function z(n) {
      var i = Math.floor(Math.abs(v(n / e))),
        r = v(((n % e) + e) % e);
      r === e && (r = 0);
      var a = l(n),
        o = c.indexOf(
          t([], c, !0).reduce(function (n, t) {
            return Math.abs(t - r) < Math.abs(n - r) ? t : n;
          })
        ),
        u = o;
      return (
        a < 0 && i++,
        o === s && ((u = 0), (i += a > 0 ? 1 : -1)),
        { abs: u + i * s * a, origin: o, rel: u }
      );
    }
    function I(n, t, i) {
      var e;
      if (t || !S()) return A(n, i);
      if (!D(n)) return null;
      var r = z(null != i ? i : T),
        a = r.abs,
        o = n - r.rel,
        u = a + o;
      e = A(u);
      var c = A(u - s * l(o));
      return (
        ((null !== c && Math.abs(c) < Math.abs(e)) || null === e) && (e = c),
        v(e)
      );
    }
    function A(n, t) {
      if ((null == t && (t = v(T)), !D(n) || null === n)) return null;
      n = Math.round(n);
      var i = z(t),
        r = i.abs,
        a = i.rel,
        o = i.origin,
        u = O(n),
        d = ((t % e) + e) % e,
        l = c[o],
        f = Math.floor((n - (r - a)) / s) * e;
      return v(l - d - l + c[u] + f + (o === s ? e : 0));
    }
    function D(n) {
      return L(n) === n;
    }
    function L(n) {
      return d(n, h, m);
    }
    function S() {
      return o.loop;
    }
    function O(n) {
      return ((n % s) + s) % s;
    }
    function _(t) {
      var i;
      (i = t - T),
        w.push({ distance: i, timestamp: r() }),
        w.length > 6 && (w = w.slice(-6)),
        (T = v(t));
      var e = H().abs;
      if (e !== M) {
        var a = null !== M;
        (M = e), a && n.emit("slideChanged");
      }
    }
    function H(t) {
      var r = t
        ? null
        : (function () {
            if (s) {
              var n = S(),
                t = n ? ((T % e) + e) % e : T,
                i = (n ? T % e : T) - u[0][2],
                r = 0 - (i < 0 && n ? e - Math.abs(i) : i),
                c = 0,
                d = z(T),
                f = d.abs,
                p = d.rel,
                v = u[p][2],
                k = u.map(function (t, i) {
                  var a = r + c;
                  (a < 0 - t[0] || a > 1) &&
                    (a += (Math.abs(a) > e - 1 && n ? e : 0) * l(-a));
                  var u = i - p,
                    d = l(u),
                    h = u + f;
                  n &&
                    (-1 === d && a > v && (h += s),
                    1 === d && a < v && (h -= s),
                    null !== g && h < g && (a += e),
                    null !== b && h > b && (a -= e));
                  var m = a + t[0] + t[1],
                    x = Math.max(
                      a >= 0 && m <= 1
                        ? 1
                        : m < 0 || a > 1
                        ? 0
                        : a < 0
                        ? Math.min(1, (t[0] + a) / t[0])
                        : (1 - a) / t[0],
                      0
                    );
                  return (
                    (c += t[0] + t[1]),
                    {
                      abs: h,
                      distance: o.rtl ? -1 * a + 1 - t[0] : a,
                      portion: x,
                      size: t[0],
                    }
                  );
                });
              return (
                (f = L(f)),
                (p = O(f)),
                {
                  abs: L(f),
                  length: a,
                  max: y,
                  maxIdx: m,
                  min: x,
                  minIdx: h,
                  position: T,
                  progress: n ? t / e : T / a,
                  rel: p,
                  slides: k,
                  slidesLength: e,
                }
              );
            }
          })();
      return (i.details = r), n.emit("detailsChanged"), r;
    }
    return (i = {
      absToRel: O,
      add: C,
      details: null,
      distToIdx: E,
      idxToDist: I,
      init: function (t) {
        if (
          ((function () {
            if (
              ((o = n.options),
              (u = (o.trackConfig || []).map(function (n) {
                return [p(n, "size", 1), p(n, "spacing", 0), p(n, "origin", 0)];
              })),
              (s = u.length))
            ) {
              e = v(
                u.reduce(function (n, t) {
                  return n + t[0] + t[1];
                }, 0)
              );
              var t,
                i = s - 1;
              (a = v(e + u[0][2] - u[i][0] - u[i][2] - u[i][1])),
                (c = u.reduce(function (n, i) {
                  if (!n) return [0];
                  var e = u[n.length - 1],
                    r = n[n.length - 1] + (e[0] + e[2]) + e[1];
                  return (
                    (r -= i[2]),
                    n[n.length - 1] > r && (r = n[n.length - 1]),
                    (r = v(r)),
                    n.push(r),
                    (!t || t < r) && (f = n.length - 1),
                    (t = r),
                    n
                  );
                }, null)),
                0 === a && (f = 0),
                c.push(v(e));
            }
          })(),
          !s)
        )
          return H(!0);
        var i;
        !(function () {
          var t = n.options.range,
            i = n.options.loop;
          (g = h = i ? p(i, "min", -1 / 0) : 0),
            (b = m = i ? p(i, "max", k) : f);
          var e = p(t, "min", null),
            r = p(t, "max", null);
          e && (h = e),
            r && (m = r),
            (x = h === -1 / 0 ? h : n.track.idxToDist(h || 0, !0, 0)),
            (y = m === k ? m : I(m, !0, 0)),
            null === r && (b = m),
            p(t, "align", !1) &&
              m !== k &&
              0 === u[O(m)][2] &&
              ((y -= 1 - u[O(m)][0]), (m = E(y - T))),
            (x = v(x)),
            (y = v(y));
        })(),
          (i = t),
          Number(i) === i ? C(A(L(t))) : H();
      },
      to: _,
      velocity: function () {
        var n = r(),
          t = w.reduce(
            function (t, i) {
              var e = i.distance,
                r = i.timestamp;
              return (
                n - r > 200 ||
                  (l(e) !== l(t.distance) &&
                    t.distance &&
                    (t = { distance: 0, lastTimestamp: 0, time: 0 }),
                  t.time && (t.distance += e),
                  t.lastTimestamp && (t.time += r - t.lastTimestamp),
                  (t.lastTimestamp = r)),
                t
              );
            },
            { distance: 0, lastTimestamp: 0, time: 0 }
          );
        return t.distance / t.time || 0;
      },
    });
  }
  function g(n) {
    var t, i, e, r, a, o, u, s;
    function c(n) {
      return 2 * n;
    }
    function f(n) {
      return d(n, u, s);
    }
    function p(n) {
      return 1 - Math.pow(1 - n, 3);
    }
    function v() {
      return e ? n.track.velocity() : 0;
    }
    function h() {
      b();
      var t = "free-snap" === n.options.mode,
        i = n.track,
        e = v();
      r = l(e);
      var u = n.track.details,
        s = [];
      if (e || !t) {
        var d = m(e),
          h = d.dist,
          g = d.dur;
        if (((g = c(g)), (h *= r), t)) {
          var x = i.idxToDist(i.distToIdx(h), !0);
          x && (h = x);
        }
        s.push({ distance: h, duration: g, easing: p });
        var y = u.position,
          k = y + h;
        if (k < a || k > o) {
          var w = k < a ? a - y : o - y,
            M = 0,
            T = e;
          if (l(w) === r) {
            var C = Math.min(Math.abs(w) / Math.abs(h), 1),
              E =
                (function (n) {
                  return 1 - Math.pow(1 - n, 1 / 3);
                })(C) * g;
            (s[0].earlyExit = E), (T = e * (1 - C));
          } else (s[0].earlyExit = 0), (M += w);
          var z = m(T, 100),
            I = z.dist * r;
          n.options.rubberband &&
            (s.push({ distance: I, duration: c(z.dur), easing: p }),
            s.push({ distance: -I + M, duration: 500, easing: p }));
        }
        n.animator.start(s);
      } else
        n.moveToIdx(f(u.abs), !0, {
          duration: 500,
          easing: function (n) {
            return 1 + --n * n * n * n * n;
          },
        });
    }
    function m(n, t) {
      void 0 === t && (t = 1e3);
      var i = 147e-9 + (n = Math.abs(n)) / t;
      return { dist: Math.pow(n, 2) / i, dur: n / i };
    }
    function g() {
      var t = n.track.details;
      t && ((a = t.min), (o = t.max), (u = t.minIdx), (s = t.maxIdx));
    }
    function b() {
      n.animator.stop();
    }
    n.on("updated", g),
      n.on("optionsChanged", g),
      n.on("created", g),
      n.on("dragStarted", function () {
        (e = !1), b(), (t = i = n.track.details.abs);
      }),
      n.on("dragChecked", function () {
        e = !0;
      }),
      n.on("dragEnded", function () {
        var e = n.options.mode;
        "snap" === e &&
          (function () {
            var e = n.track,
              r = n.track.details,
              u = r.position,
              s = l(v());
            (u > o || u < a) && (s = 0);
            var c = t + s;
            0 === r.slides[e.absToRel(c)].portion && (c -= s),
              t !== i && (c = i),
              l(e.idxToDist(c, !0)) !== s && (c += s),
              (c = f(c));
            var d = e.idxToDist(c, !0);
            n.animator.start([
              {
                distance: d,
                duration: 500,
                easing: function (n) {
                  return 1 + --n * n * n * n * n;
                },
              },
            ]);
          })(),
          ("free" !== e && "free-snap" !== e) || h();
      }),
      n.on("dragged", function () {
        i = n.track.details.abs;
      });
  }
  function b(n) {
    var t,
      i,
      e,
      r,
      a,
      f,
      p,
      v,
      h,
      m,
      g,
      b,
      x,
      y,
      k,
      w,
      M,
      T,
      C = c();
    function E(t) {
      if (f && v === t.id) {
        var o = D(t);
        if (h) {
          if (!A(t)) return I(t);
          (m = o), (h = !1), n.emit("dragChecked");
        }
        if (w) return (m = o);
        u(t);
        var c = (function (t) {
          if (M === -1 / 0 && T === 1 / 0) return t;
          var e = n.track.details,
            o = e.length,
            u = e.position,
            s = d(t, M - u, T - u);
          if (0 === o) return 0;
          if (!n.options.rubberband) return s;
          if (u <= T && u >= M) return t;
          if ((u < M && i > 0) || (u > T && i < 0)) return t;
          var c = (u < M ? u - M : u - T) / o,
            l = r * o,
            f = Math.abs(c * l),
            p = Math.max(0, 1 - (f / a) * 2);
          return p * p * t;
        })((p(m - o) / r) * e);
        i = l(c);
        var x = n.track.details.position;
        ((x > M && x < T) || (x === M && i > 0) || (x === T && i < 0)) && s(t),
          (g += c),
          !b && Math.abs(g * r) > 5 && (b = !0),
          n.track.add(c),
          (m = o),
          n.emit("dragged");
      }
    }
    function z(t) {
      !f &&
        n.track.details &&
        n.track.details.length &&
        ((g = 0),
        (f = !0),
        (b = !1),
        (h = !0),
        (v = t.id),
        A(t),
        (m = D(t)),
        n.emit("dragStarted"));
    }
    function I(t) {
      f && v === t.idChanged && ((f = !1), n.emit("dragEnded"));
    }
    function A(n) {
      var t = L(),
        i = t ? n.y : n.x,
        e = t ? n.x : n.y,
        r = void 0 !== x && void 0 !== y && Math.abs(y - e) <= Math.abs(x - i);
      return (x = i), (y = e), r;
    }
    function D(n) {
      return L() ? n.y : n.x;
    }
    function L() {
      return n.options.vertical;
    }
    function S() {
      (r = n.size), (a = L() ? window.innerHeight : window.innerWidth);
      var t = n.track.details;
      t && ((M = t.min), (T = t.max));
    }
    function O(n) {
      b && (s(n), u(n));
    }
    function _() {
      if ((C.purge(), n.options.drag && !n.options.disabled)) {
        var i;
        (i = n.options.dragSpeed || 1),
          (p =
            "function" == typeof i
              ? i
              : function (n) {
                  return n * i;
                }),
          (e = n.options.rtl ? -1 : 1),
          S(),
          (t = n.container),
          (function () {
            var n = "data-keen-slider-clickable";
            o("[".concat(n, "]:not([").concat(n, "=false])"), t).map(function (
              n
            ) {
              C.add(n, "dragstart", s),
                C.add(n, "mousedown", s),
                C.add(n, "touchstart", s);
            });
          })(),
          C.add(t, "dragstart", function (n) {
            u(n);
          }),
          C.add(t, "click", O, { capture: !0 }),
          C.input(t, "ksDragStart", z),
          C.input(t, "ksDrag", E),
          C.input(t, "ksDragEnd", I),
          C.input(t, "mousedown", z),
          C.input(t, "mousemove", E),
          C.input(t, "mouseleave", I),
          C.input(t, "mouseup", I),
          C.input(t, "touchstart", z, { passive: !0 }),
          C.input(t, "touchmove", E, { passive: !1 }),
          C.input(t, "touchend", I),
          C.input(t, "touchcancel", I),
          C.add(window, "wheel", function (n) {
            f && u(n);
          });
        var r = "data-keen-slider-scrollable";
        o("[".concat(r, "]:not([").concat(r, "=false])"), n.container).map(
          function (n) {
            return (function (n) {
              var t;
              C.input(
                n,
                "touchstart",
                function (n) {
                  (t = D(n)), (w = !0), (k = !0);
                },
                { passive: !0 }
              ),
                C.input(n, "touchmove", function (i) {
                  var e = L(),
                    r = e
                      ? n.scrollHeight - n.clientHeight
                      : n.scrollWidth - n.clientWidth,
                    a = t - D(i),
                    o = e ? n.scrollTop : n.scrollLeft,
                    s =
                      (e && "scroll" === n.style.overflowY) ||
                      (!e && "scroll" === n.style.overflowX);
                  if (
                    ((t = D(i)),
                    ((a < 0 && o > 0) || (a > 0 && o < r)) && k && s)
                  )
                    return (w = !0);
                  (k = !1), u(i), (w = !1);
                }),
                C.input(n, "touchend", function () {
                  w = !1;
                });
            })(n);
          }
        );
      }
    }
    n.on("updated", S),
      n.on("optionsChanged", _),
      n.on("created", _),
      n.on("destroyed", C.purge);
  }
  function x(n) {
    var t,
      i,
      e = null;
    function r(t, i, e) {
      n.animator.active
        ? o(t, i, e)
        : requestAnimationFrame(function () {
            return o(t, i, e);
          });
    }
    function a() {
      r(!1, !1, i);
    }
    function o(i, r, a) {
      var o = 0,
        u = n.size,
        d = n.track.details;
      if (d && t) {
        var l = d.slides;
        t.forEach(function (n, t) {
          if (i) !e && r && s(n, null, a), c(n, null, a);
          else {
            if (!l[t]) return;
            var d = l[t].size * u;
            !e && r && s(n, d, a), c(n, l[t].distance * u - o, a), (o += d);
          }
        });
      }
    }
    function u(t) {
      return "performance" === n.options.renderMode ? Math.round(t) : t;
    }
    function s(n, t, i) {
      var e = i ? "height" : "width";
      null !== t && (t = u(t) + "px"),
        (n.style["min-" + e] = t),
        (n.style["max-" + e] = t);
    }
    function c(n, t, i) {
      if (null !== t) {
        t = u(t);
        var e = i ? t : 0;
        t = "translate3d(".concat(i ? 0 : t, "px, ").concat(e, "px, 0)");
      }
      (n.style.transform = t), (n.style["-webkit-transform"] = t);
    }
    function d() {
      t && (o(!0, !0, i), (t = null)), n.on("detailsChanged", a, !0);
    }
    function l() {
      r(!1, !0, i);
    }
    function f() {
      d(),
        (i = n.options.vertical),
        n.options.disabled ||
          "custom" === n.options.renderMode ||
          ((e = "auto" === p(n.options.slides, "perView", null)),
          n.on("detailsChanged", a),
          (t = n.slides).length && l());
    }
    n.on("created", f),
      n.on("optionsChanged", f),
      n.on("beforeOptionsChanged", function () {
        d();
      }),
      n.on("updated", l),
      n.on("destroyed", d);
  }
  function y(t, i) {
    return function (e) {
      var r,
        u,
        s,
        d,
        l,
        v,
        h = c();
      function m(n) {
        var t;
        a(
          e.container,
          "reverse",
          "rtl" !==
            ((t = e.container),
            window.getComputedStyle(t, null).getPropertyValue("direction")) || n
            ? null
            : ""
        ),
          a(e.container, "v", e.options.vertical && !n ? "" : null),
          a(e.container, "disabled", e.options.disabled && !n ? "" : null);
      }
      function g() {
        b() && M();
      }
      function b() {
        var t = null;
        if (
          (d.forEach(function (n) {
            n.matches && (t = n.__media);
          }),
          t === r)
        )
          return !1;
        r || e.emit("beforeOptionsChanged"), (r = t);
        var i = t ? s.breakpoints[t] : s;
        return (e.options = n(n({}, s), i)), m(), I(), A(), C(), !0;
      }
      function x(n) {
        var t = f(n);
        return (e.options.vertical ? t.height : t.width) / e.size || 1;
      }
      function y() {
        return e.options.trackConfig.length;
      }
      function k(t) {
        for (var a in ((r = !1),
        (s = n(n({}, i), t)),
        h.purge(),
        (u = e.size),
        (d = []),
        s.breakpoints || [])) {
          var o = window.matchMedia(a);
          (o.__media = a), d.push(o), h.add(o, "change", g);
        }
        h.add(window, "orientationchange", z), h.add(window, "resize", E), b();
      }
      function w(n) {
        e.animator.stop();
        var t = e.track.details;
        e.track.init(null != n ? n : t ? t.abs : 0);
      }
      function M(n) {
        w(n), e.emit("optionsChanged");
      }
      function T(n, t) {
        if (n) return k(n), void M(t);
        I(), A();
        var i = y();
        C(), y() !== i ? M(t) : w(t), e.emit("updated");
      }
      function C() {
        var n = e.options.slides;
        if ("function" == typeof n)
          return (e.options.trackConfig = n(e.size, e.slides));
        for (
          var t = e.slides,
            i = t.length,
            r = "number" == typeof n ? n : p(n, "number", i, !0),
            a = [],
            o = p(n, "perView", 1, !0),
            u = p(n, "spacing", 0, !0) / e.size || 0,
            s = "auto" === o ? u : u / o,
            c = p(n, "origin", "auto"),
            d = 0,
            l = 0;
          l < r;
          l++
        ) {
          var f = "auto" === o ? x(t[l]) : 1 / o - u + s,
            v = "center" === c ? 0.5 - f / 2 : "auto" === c ? 0 : c;
          a.push({ origin: v, size: f, spacing: u }), (d += f);
        }
        if (((d += u * (r - 1)), "auto" === c && !e.options.loop && 1 !== o)) {
          var h = 0;
          a.map(function (n) {
            var t = d - h;
            return (
              (h += n.size + u),
              t >= 1 || (n.origin = 1 - t - (d > 1 ? 0 : 1 - d)),
              n
            );
          });
        }
        e.options.trackConfig = a;
      }
      function E() {
        I();
        var n = e.size;
        e.options.disabled || n === u || ((u = n), T());
      }
      function z() {
        E(), setTimeout(E, 500), setTimeout(E, 2e3);
      }
      function I() {
        var n = f(e.container);
        e.size = (e.options.vertical ? n.height : n.width) || 1;
      }
      function A() {
        e.slides = o(e.options.selector, e.container);
      }
      (e.container = (v = o(t, l || document)).length ? v[0] : null),
        (e.destroy = function () {
          h.purge(), e.emit("destroyed"), m(!0);
        }),
        (e.prev = function () {
          e.moveToIdx(e.track.details.abs - 1, !0);
        }),
        (e.next = function () {
          e.moveToIdx(e.track.details.abs + 1, !0);
        }),
        (e.update = T),
        k(e.options);
    };
  }
  return function (n, i, e) {
    try {
      return (function (n, t) {
        var i,
          e = {};
        return (
          (i = {
            emit: function (n) {
              e[n] &&
                e[n].forEach(function (n) {
                  n(i);
                });
              var t = i.options && i.options[n];
              t && t(i);
            },
            moveToIdx: function (n, t, e) {
              var r = i.track.idxToDist(n, t);
              if (r) {
                var a = i.options.defaultAnimation;
                i.animator.start([
                  {
                    distance: r,
                    duration: p(e || a, "duration", 500),
                    easing: p(e || a, "easing", function (n) {
                      return 1 + --n * n * n * n * n;
                    }),
                  },
                ]);
              }
            },
            on: function (n, t, i) {
              void 0 === i && (i = !1), e[n] || (e[n] = []);
              var r = e[n].indexOf(t);
              r > -1 ? i && delete e[n][r] : i || e[n].push(t);
            },
            options: n,
          }),
          (function () {
            if (((i.track = m(i)), (i.animator = h(i)), t))
              for (var n = 0, e = t; n < e.length; n++) (0, e[n])(i);
            i.track.init(i.options.initial || 0), i.emit("created");
          })(),
          i
        );
      })(
        i,
        t(
          [
            y(n, {
              drag: !0,
              mode: "snap",
              renderMode: "precision",
              rubberband: !0,
              selector: ".keen-slider__slide",
            }),
            x,
            b,
            g,
          ],
          e || [],
          !0
        )
      );
    } catch (n) {
      console.error(n);
    }
  };
});


/**
 * * Helper functions
 * 
 * 
 * 
 * 
 */
 function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail: data,
    })
  );
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: false,
      detail: data,
    })
  );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (domElement.hasAttribute("section") && domElement.getAttribute("section") === event.detail.sectionId) {
      executeCallback = true;
    }
  } else if (event.type.includes("shopify:block") && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
 ** Shopify Common JS
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    console.log("selecotr", selector)
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


/**
 * * UI elements
 * 
 * 
 * 
 * 
 * 
 */
 class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


/**
 * *Store Header
 * 
 */
class StoreHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.header = document.getElementById('shopify-section-header');
    this.header = this
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.primaryLogo = this.querySelector('.logo--primary')
    this.secondaryLogo = this.querySelector('.logo--secondary')
    // this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();

    // this.addEventListener('mouseenter', () => this.fillColor())
    // this.addEventListener('mouseleave', () => this.removeFillColor())
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop =  document.documentElement.scrollTop;
    // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // console.log("headerBounds", this.headerBounds)
    if (scrollTop > this.headerBounds.bottom) { 
      if (this.preventHide) return;
        requestAnimationFrame(this.fillColor.bind(this));

        // if (this.primaryLogo) requestAnimationFrame(this.switchPrimaryLogo.bind(this));
        
    } else {
      requestAnimationFrame(this.removeFillColor.bind(this));
      // if (this.secondaryLogo) requestAnimationFrame(this.switchSecondaryLogo.bind(this));
    }


  }

  fillColor() {
    this.header.classList.add('is-filled');
  }

  removeFillColor() {
    this.header.classList.remove('is-filled');
  }

  // switchPrimaryLogo() {
  //   this.primaryLogo.classList.remove('invisible')
  //   this.secondaryLogo.classList.add('invisible')
  // }
  // switchSecondaryLogo() {
  //   this.secondaryLogo.classList.remove('visible')
  //   this.primaryLogo.classList.add('visible')
  // }

}

window.customElements.define('store-header', StoreHeader);

/**
 * * Product Form
 * * Includes:
 * * ProductVariants, ProductForm, QuantityInput
 * 
 * 
 */

/**
 * * Variant Selects
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    // this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    this.options = Array.from(this.querySelectorAll('input[checked]'), (checked) => checked.value)
    console.log("updateOptions", this.options)
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option
      }).includes(false)
    })

    console.log("updatemaster", this.currentVariant) 
  }

  // updateMedia() {
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;

  //   const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
  //   mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

  //   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  //   if (!modalContent) return;
  //   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
  //   modalContent.prepend(newMediaModal);
  // }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('sr-only');
        this.toggleAddButton(!this.currentVariant.available, window.themeVariables.strings.soldOut);
      });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.themeVariables.strings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('sr-only');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData;
  }

}

window.customElements.define('variant-selects', VariantSelects);

/**
 * * Variant Radios
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
  }
}

window.customElements.define('variant-radios', VariantRadios);

/**
 * * ProductVariants
 * ! Depreciated
 */
// class ProductVariants extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('change', this.onVariantChange);
//   }

//   onVariantChange() {
//     // alert("change")
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     // this.updatePickupAvailability();
//     // this.removeErrorMessage();

//     if (!this.currentVariant) {
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     } else {
//       // this.updateMedia();
//       this.updateURL();
//       this.updateVariantInput();
//       this.renderProductInfo();
//       // this.updateShareUrl();
//     }
//   }

//   updateOptions() {
//     this.options = Array.from(
//       this.querySelectorAll('select'),
//       (select) => select.value,
//     );

//     // console.log(this.options)
//   }

//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//     window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

//   updateVariantInput() {
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
//     // console.log("this.dataset.section", this.dataset.section)
//     productForms.forEach((productForm) => {
//       const input = productForm.querySelector('input[name="id"]');
//       input.value = this.currentVariant.id;
//       const change = input.dispatchEvent(new Event('change', { bubbles: true }));

//     });
//   }


//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options
//         .map((option, index) => {
//           return this.options[index] === option;
//         })
//         .includes(false);
//     });

//     console.log("currentVariant", this.currentVariant)
//   }

//   getVariantData() {
//     this.variantData =
//       this.variantData ||
//       JSON.parse(this.querySelector('[type="application/json"]').textContent);

//     console.log("variantData", this.variantData)
//     return this.variantData;
//   }

//   renderProductInfo() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const html = new DOMParser().parseFromString(responseText, 'text/html')
//         const destination = document.getElementById(`price-${this.dataset.section}`);
//         console.log("destination", destination)

//         const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
//         console.log("source", source)

//         if (source && destination) destination.innerHTML = source.innerHTML;

//         const price = document.getElementById(`price-${this.dataset.section}`);
//         if (price) price.classList.remove('sr-only');
//         this.toggleAddButton(!this.currentVariant.available, window.themeVariables.strings.soldOut);
//       })

//   }

//   setUnavailable() {
//     const button = document.getElementById(
//       `product-form-${this.dataset.section}`,
//     );
//     console.log("button", button)
//     const addButton = button.querySelector('[name="add"]');
//     const addButtonText = button.querySelector('[name="add"] > span');
//     const price = document.getElementById(`price-${this.dataset.section}`);
//     if (!addButton) return;
//     addButtonText.textContent = window.themeVariables.strings.unavailable;
//     if (price) price.classList.add('invisible');
//   }

//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(this.getAttribute("form-id"));
//     console.log("productForm", productForm)

//     if (!productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     const addButtonText = productForm.querySelector('[name="add"] > span');

//     console.log("addButton", addButton)
//     console.log("addButtonText", addButtonText)

//     if (!addButton) return;

//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//     } else {
//       addButton.removeAttribute('disabled');
//       addButtonText.textContent = window.themeVariables.strings.addToCart;
//     }

//     if (!modifyClass) return;
//   }

//   connectedCallback() {
//     //implementation
//   }

//   disconnectedCallback() {
//     //implementation
//   }

//   attributeChangedCallback(name, oldVal, newVal) {
//     //implementation
//   }

//   adoptedCallback() {
//     //implementation
//   }

// }
// window.customElements.define('product-variants', ProductVariants);

/**
 * * ProductForm
 * 
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector("cart-drawer"))
      this.submitButton.setAttribute("aria-haspopup", "dialog");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === "true") return

    // this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true)
    this.submitButton.classList.add("is-loading")
    this.querySelector('.loader-spinner').classList.remove('hidden');

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${themeVariables.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        console.log("response", response)
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
          
        } else if (!this.cart) {
          window.location = window.themeVariables.routes.cart_url;
          return;
        }

        this.error = false;

        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          // document.body.addEventListener('modalClosed', () => {
          //   setTimeout(() => { this.cart.renderContents(response) });
          // }, { once: true });
          // quickAddModal.hide(true);
        } else {
          // cart notification
          this.cart.renderContents(response);
          console.log("this,cart res", response);
        }
      })
      .catch((e) => console.error("ProductForm E", e))
      .finally((e) => {
        this.submitButton.classList.remove("is-loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loader-spinner").classList.add("hidden");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

window.customElements.define('product-form', ProductForm);

/**
 * * QuantityInput
 * 
 * 
 * 
 * 
 */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input")
    this.changeEvent = new Event('change', {bubbles: true})

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // event.target.name === 'plus' ? console.log("+") : console.log("-")
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

}

window.customElements.define('quantity-input', QuantityInput);


/**
 * * Cart Remove
 */
 class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      console.log("cartItems", cartItems)
      console.log("this.dataset.index, 0", this.dataset.index, 0)
    });
  }
}

window.customElements.define('cart-remove', CartRemove);


/**
 * * Cart Items
 * 
 */
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      // {
      //   id: 'main-cart-summary',
      //   section: document.getElementById('main-cart-summary').dataset.id,
      //   selector: '.js-cart-summary'
      // },
      // {
      //   id: 'cart-drawer',
      //   selector: '#CartDrawer'
      // },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      // {
      //   id: 'main-cart-summary',
      //   section: `main-cart-summary-${document.getElementById('main-cart-items').dataset.id}`,
      //   // section: 'cart-summary',
      //   selector: '.js-cart-summary'
      // },
    ];
  }

  updateQuantity(line, quantity, name) {
    // this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })
    

    fetch(`${themeVariables.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        console.log("parsedState", parsedState)

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartSummary = document.getElementById('main-cart-summary');
        console.log("cartSummary", cartSummary)
        if (cartSummary) cartSummary.classList.toggle('is-empty', parsedState.item_count === 0);


        const cartLayout = document.getElementById('main-cart-layout');
        if (cartLayout) cartLayout.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          console.log("section", section)

          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          console.log("elementToReplace", elementToReplace)
            
            
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

            // console.log("elementToReplace.innerHTML", elementToReplace.innerHTML)
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        // console.log("lineItem", lineItem)
        // console.log("lineItemQS", lineItem.querySelector(`[name="${name}"]`))


      })
      .catch((e) => {
        console.log("cartItems error", e)
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.themeVariables.cartStrings.error;
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      // lineItemError.classList.remove("hidden")

      lineItemError.classList.remove("hidden")

      console.log("lineitem error", lineItemError)
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.themeVariables.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

}

window.customElements.define('cart-items', CartItems);

/**
 * * Cart Note
 */
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      console.log("carnote", body)
      fetch(`${themeVariables.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300))
  }
}

window.customElements.define('cart-note', CartNote);

/**
 * * Cart types
 * * Includes
 * * Drawer, Notification, Page
 * 
 */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.cart-drawer__main').classList.contains('is-empty') && this.querySelector('.cart-drawer__main').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

}

window.customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__main'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById("cart-notification")
    this.header = document.querySelector("store-header")
    this.onBodyClick = this.handleBodyClick.bind(this)

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener("mouseenter", this.stopTimer.bind(this))
    this.addEventListener("mouseleave", this.startTimer.bind(this))
  }

  startTimer() {
    console.log("startTimer")
    this.timeout = setTimeout(() => {
      this.close();
    }, 3000)
  }

  stopTimer() {
    console.log("stopTimer")
    clearTimeout(this.timeout)
  }

  open() {
    console.log("open")
    this.notification.classList.add('animate', 'is-active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      // trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    // setTimeout(() => {
    //   this.close();
    // }, 3000)

    this.startTimer();
  }

  close() {
    this.notification.classList.remove('is-active');
    document.body.removeEventListener('click', this.onBodyClick);
    // removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log("notification parsedState",parsedState.key)
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      console.log("section", section)
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    // if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      // {
      //   id: 'cart-notification-button'
      // },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }


}

window.customElements.define('cart-notification', CartNotification);


/**
 * * Main Login
 */

class MainLogin extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.recoveryTrigger = this.querySelector("#recovery-trigger")
    this.loginTrigger = this.querySelector("#login-trigger")
    this.loginForm = this.querySelector("#main-login")
    this.recoveryForm = this.querySelector("#main-login-recovery")
    this.recoverySuccess = this.getAttribute('recovery-success')
    console.log("this.recoverySuccess", this.recoverySuccess)

    this.recoveryTrigger.addEventListener("click", () => {
      this.switchForm()
    })
    this.loginTrigger.addEventListener("click", () => {
      this.switchForm()
    })
  }

  switchForm() {
    console.log("toggle")
    if (this.recoverySuccess === "true") {
      this.loginForm.classList.toggle("hidden")
      this.recoveryForm.classList.toggle("hidden")

    } else {
      this.loginForm.classList.toggle("hidden")
      this.recoveryForm.classList.toggle("hidden")

    }
  }


}

window.customElements.define('main-login', MainLogin);


/**
 * * Modal Dialog
 */

class DrawerDialog extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    // this.closeButton = this.querySelector('button[is="close"]')
    this.closeButtons = this.querySelectorAll('button[is="close"]')
    this.modalOverlay = this.querySelector(".modal-overlay");
    this.drawer = this.querySelector("aside");
    // this.cancelButton = this.querySelector('button[type="reset"]')

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.setAttribute("role", "button");

    // close with escape
    this.details.addEventListener("keyup", (event) => {
      console.log("eventcode", event.code)
      if (event.code) event.code.toUpperCase() === "ESCAPE" && this.close();
    });


    // event listener on summary click
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));

    // this.closeButton.addEventListener('click', this.close.bind(this))

    this.closeButtons.forEach((button) => button.addEventListener('click', this.close.bind(this)))

    this.modalOverlay.addEventListener("click", this.close.bind(this));

    if (this.cancelbutton) this.cancelbutton.addEventListener("click", this.close.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open() {
    this.onBodyClick = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", "");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    window.requestAnimationFrame(() => this.openAnimation());
  }

  openAnimation() {
    this.isExpanding = true;
    if (this.animation) this.animation.cancel();

    this.animation = this.drawer.animate({
      transform: ['translateX(-100%)', 'translateX(0)']
    }, {
      duration: 300,
      easing: 'ease-out'
    })
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  close() {
    console.log("CLOSE")
    window.requestAnimationFrame(() => this.closeAnimation());
  }

  closeAnimation() {
    this.isClosing = true

    if (this.animation) this.animation.cancel()

    this.animation = this.drawer.animate({
      transform: ['translateX(0)', 'translateX(-100%)']
    }, {
      duration: 300,
      easing: 'ease-out'
    })

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener('click', this.onBodyClickEvent)
      document.body.classList.remove('overflow-hidden')
    }
  }
}

window.customElements.define('drawer-dialog', DrawerDialog);


/**
 * * Account Addresses
 */
class AddAddressDrawer extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details')
    this.summaryToggle = this.querySelector('summary')
    this.closeButton = this.querySelector('button[type="button"]') 
    this.modalOverlay = this.querySelector('.modal-overlay')
    this.drawerContent = this.querySelector('#drawer-content')


    // animations
    this.animation = null
    this.isClosing = false
    this.isExpanding = false

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.closeButton.addEventListener('click', this.close.bind(this))
    this.modalOverlay.addEventListener('click', this.close.bind(this))

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    // const isOpen = detailsElement.hasAttribute('open');
    

    // if (isOpen) event.preventDefault();
    // isOpen ? this.close(event, summaryElement) : this.open(summaryElement)

    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event)
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false)
  }

  open(event) {
    this.onBodyClick = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', "");
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    
    window.requestAnimationFrame(() => this.openAnimation());
    // trapFocus(
    //   this.detailsContainer.querySelector('[tabindex="-1"]'),
    //   this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );
  }

  openAnimation() {
    this.isExpanding = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.drawerContent.animate({
      transform: ['translateX(-100%)', 'translateX(0)']
    }, {
      duration: 300,
      easing: 'ease-in-out'
    })
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  close(focusToggle = true) {
    // this.detailsContainer.removeAttribute('open')
    // document.body.removeEventListener('click', this.onBodyClickEvent)
    // document.body.classList.remove('overflow-hidden')

    window.requestAnimationFrame(() => this.closeAnimation());
  }

  closeAnimation() {
    this.isClosing = true

    // if (this.animation) this.animation.cancel()

    this.animation = this.drawerContent.animate({
      transform: ['translateX(0)', 'translateX(-100%)']
    }, {
      duration: 300,
      easing: 'ease-out'
    })

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  onAnimationFinish(open) {
    this.detailsContainer.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener('click', this.onBodyClickEvent)
      document.body.classList.remove('overflow-hidden')
    }
  }
  

}

window.customElements.define('add-address', AddAddressDrawer);


/**
 * * Facet Filter Form
 */
 class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    // this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
      // console.log("button", button)
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeMenu(detailsElement);
  }

  closeMenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


 class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input')
//       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
//     this.setMinAndMaxValues();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('min', 0);
//     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }
// }

// customElements.define('price-range', PriceRange);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    //implementation
    const rangeSliderFrom = this.querySelector('.range-group-slider input:first-child')
    const rangeSliderTo = this.querySelector('.range-group-slider input:last-child')
    const inputFrom = this.querySelector('.range-group-input .range-input:first-child input')
    const inputTo = this.querySelector('.range-group-input .range-input:last-child input')

    inputFrom.addEventListener('input', (event) => {
      console.log("event", event.target.value)
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(inputTo.value || event.target.max) - 1), event.target.min);
      rangeSliderFrom.value = event.target.value
      rangeSliderFrom.parentElement.style.setProperty('--range-min', `${parseInt(rangeSliderFrom.value) / parseInt(rangeSliderFrom.max) * 100}%`)
    })

    inputTo.addEventListener('input', (event) => {
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(inputFrom.value || event.target.min) + 1), event.target.max);
      rangeSliderTo.value = event.target.value;
      rangeSliderTo.parentElement.style.setProperty('--range-max', `${parseInt(rangeSliderTo.value) / parseInt(rangeSliderTo.max) * 100}%`)
    })

    rangeSliderFrom.addEventListener('change', (event) => {
      inputFrom.value = event.target.value
    })
    rangeSliderTo.addEventListener('change', (event) => {
      inputTo.value = event.target.value
    })

    rangeSliderFrom.addEventListener('input', (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(inputTo.value || event.target.max) -1)
      inputFrom.value = event.target.value
      event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
    })

    rangeSliderTo.addEventListener('input', (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(inputFrom.value || event.target.min) + 1)
      inputTo.value = event.target.value
      event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`)
    })
  }

}

window.customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 * * Product Images
 */

class LazyImage extends HTMLElement {
  constructor() {
    super();

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          let img = lazyImage.querySelector('img')
          img.src = img.dataset.src;
          lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.add("fade-in")

          observer.unobserve(lazyImage);
        }
      })
    }, {rootMargin: `0px 0px -100px 0px`})

    observer.observe(this);
  }

}

window.customElements.define('lazy-image', LazyImage);


class CustomSelect extends HTMLElement {
  constructor() {
    super();
      // const selectedLabel = this.querySelector('.selected-label')
      const selectedValue = this.querySelector('input:checked')
      const radios = this.querySelectorAll('input[type="radio"]')
      const detail = this.querySelector('details')
      const selectedLabel = detail.querySelector('.selected-label')


      // console.log("detail", detail)

      document.addEventListener("click", (event) => {
        const isClickInside = detail.contains(event.target)

        if (!isClickInside) {
          detail.removeAttribute('open')
        }
      })
      

      radios.forEach((radio, index) => {
        radio.addEventListener('click', () => {
          console.log("selectedLabel", selectedLabel)
          // selectedLabel.textContent = radio.getAttribute('title')
          if (selectedLabel) selectedLabel.textContent = radio.getAttribute('title')
          

          console.log("click", radio.getAttribute('title'))
          detail.removeAttribute('open')
        })
      })
    }

}

window.customElements.define('custom-select', CustomSelect);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    const config = JSON.parse(this.getAttribute("slider-config"));
    console.log("config", config);
    const useResizePlugin = this.getAttribute("resize-plugin");
    const useNavigation = this.getAttribute("navigation");
    const useAutoPlay = this.getAttribute("autoplay");
    // console.log("useNavigation",useNavigation)
    // console.log("useAutoPlay",useAutoPlay)

    let plugins = [];

    if (useNavigation && !useAutoPlay)
      (plugins = [this.navigation, this.resizePlugin]), console.log("a");
    if (!useNavigation && useAutoPlay)
      (plugins = [this.autoPlay, this.resizePlugin]), console.log("b");
    if (!useNavigation && !useAutoPlay)
      (plugins = [this.resizePlugin]), console.log("c");
    if (useNavigation && useAutoPlay)
      (plugins = [this.navigation, this.autoPlay, this.resizePlugin]),
        console.log("d");

    var slider = new KeenSlider(this, config, plugins);
  }

  resizePlugin(slider) {
    const observer = new ResizeObserver(function () {
      slider.update();
    });

    slider.on("created", () => {
      observer.observe(slider.container);
    });
    slider.on("destroyed", () => {
      observer.unobserve(slider.container);
    });
  }

  navigation(slider) {
    console.log("slider", slider);

    // console.log("navigation", slider.container.getAttribute('navigation'))
    const navigationConfig = slider.container.getAttribute("navigation");

    const arrowLeft = slider.container.querySelector(".arrow--left");
    const arrowRight = slider.container.querySelector(".arrow--right");

    const dotsWrapper = slider.container.querySelector(".dots");

    // console.log("arrowLeft", arrowLeft)
    // const arrowLeft = this.querySelector('.arrow--left')

    slider.on("created", () => {
      if (navigationConfig === "arrows" || navigationConfig == "full") {
        console.log("arrowLeft", arrowLeft);
        arrowLeft.addEventListener("click", () => {
          slider.prev();
        });
        arrowRight.addEventListener("click", () => {
          slider.next();
        });
      }

      if (navigationConfig == "dots" || navigationConfig == "full") {
        slider.track.details.slides.forEach((_e, idx) => {
          console.log("_e", _e);
          // var dots = createDiv("dot")
          // dot.addEventListener("click", () => slider.moveToIdx(idx))
          // dotsWrapper.appendChild(dot)

          var dot = document.createElement("button");
          dot.classList.add("dot");
          dot.setAttribute('aria-label', 'Slide ' + (idx + 1))
          dotsWrapper.appendChild(dot);
          dot.addEventListener("click", () => slider.moveToIdx(idx));
          // dot.addEventListener("click", () => slider.moveToIdx(idx))
        });
      }

      updateClasses(slider);
    });
    slider.on("optionsChanged", () => {
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
    });
    // slider.on("destroyed", () => {
    //   markup(true);
    // });

    function updateClasses() {
      var slide = slider.track.details.rel;
      console.log("slide", slide);

      if (navigationConfig === "arrows" || navigationConfig == "full") {
        slide === 0
          ? arrowLeft.classList.add("arrow--disabled")
          : arrowLeft.classList.remove("arrow--disabled");

        slide === slider.track.details.slides.length - 1
          ? arrowRight.classList.add("arrow--disabled")
          : arrowRight.classList.remove("arrow--disabled");
      }

      if (navigationConfig == "dots" || navigationConfig == "full") {
        const dots = slider.container.querySelector(".dots");
        Array.from(dots.children).forEach((dot, idx) => {
          idx === slide
            ? dot.classList.add("dot--active")
            : dot.classList.remove("dot--active");
        });
      }
    }
  }

  autoPlay(slider) {
    let timeout;
    let mouseOver = false;

    console.log("slider", slider);
    const autoplayInterval = slider.container.getAttribute("autoplay") * 1000;
    console.log("autoplayInterval", autoplayInterval);

    function clearNextTimeout() {
      clearTimeout(timeout);
    }
    function nextTimeout() {
      clearTimeout(timeout);
      if (mouseOver) return;
      timeout = setTimeout(() => {
        slider.next();
      }, autoplayInterval);
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });
    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
  }
}

window.customElements.define("keen-slider", SliderComponent);


class ZoomGallery extends HTMLElement {
  constructor() {
    super();
    //implementation
    const detail = this.querySelector('details')
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    // this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
  }

  close() {
    const detail = this.querySelector('details')
    this.classList.remove('active');
    detail.removeAttribute('open')
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
 

}

window.customElements.define('zoom-gallery', ZoomGallery);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    //implementation
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    const detail = this.querySelector('details')
    
    this.addEventListener('mouseenter', () => this.open())

    this.addEventListener('mouseleave', () => this.close())
  }

  open() {
    const detail = this.querySelector('details')
    detail.setAttribute('open', '')
    // setTimeout(() => {this.classList.add('animate', 'active')});
    window.requestAnimationFrame(() => this.openAnimation());
    
  }

  close() {
    const detail = this.querySelector('details')
    detail.removeAttribute('open')
    // this.classList.remove('active', 'animate');
    // setTimeout(() => {this.classList.remove('animate', 'active')});
    window.requestAnimationFrame(() => this.closeAnimation());
  }

  openAnimation() {
    this.isExpanding = true;
    if (this.animation) this.animation.cancel();

    this.animation = this.querySelector('.mega-menu__main').animate({
      // transform: ['translateY(-100%)', 'translateY(0)'],
      visbility: "visible",
      opacity: [0,1]
    }, {
      duration: 300,
      easing: 'ease-out'
    })
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }
  
  closeAnimation() {
    this.isClosing = true

    if (this.animation) this.animation.cancel()

    this.animation = this.querySelector('.mega-menu__main').animate({
      opacity: [1, 0],
      visbility: "hidden",
    }, {
      duration: 300,
      easing: 'ease-out'
    })

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  onAnimationFinish(open) {
    // this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      // document.body.removeEventListener('click', this.onBodyClickEvent)
      // document.body.classList.remove('overflow-hidden')
    }
  }
}

window.customElements.define('mega-menu', MegaMenu);

class TabComponent extends HTMLElement {
  constructor() {
    super();
    const tabs = this.querySelectorAll('tab-component-nav')
    const panels = this.querySelectorAll('tab-component-panel')
    const selectedTab = this.querySelector('[selected]')
    const selectedPanel = this.querySelector(`#${selectedTab.id}`)

    tabs.forEach(tab => {
      tab.addEventListener('click', (evt) => {
        tabs.forEach(tab => {
          tab.setAttribute('aria-selected', false)
          tab.removeAttribute('selected')
        });
        tab.setAttribute('aria-selected', true)
        tab.setAttribute('selected', '')

        const panelId = this.querySelector(`#${tab.getAttribute('aria-controls')}`)
        
        panels.forEach(panel => {
          panel.setAttribute('aria-hidden', true)
        })
        panelId.setAttribute('aria-hidden', false)
      })
    });
  }

}

window.customElements.define('tab-component', TabComponent);


class StaggerGrid extends HTMLElement {
  constructor() {
    super();
    //implementation

    const targets = [...this.querySelectorAll('[stagger-item]')]
    console.log("targets", targets)
    
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const duration = reducedMotion ? .01 : 400
    const stagger = reducedMotion ? 0 : 50

    const observer = new IntersectionObserver((entries, observer, index) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {

          console.log("entrytraget", entry.target)


          entry.target.animate(
            {
              transform: ["translateY(1rem)", "translateY(0)"],
              opacity: [0, 1],
              easing: "ease-out",
            },
            {
              duration: 500,
              fill: "both",
              delay: duration * 0.5 + index * stagger,
            }
          );
          entry.target.classList.add('animated')

          observer.unobserve(entry.target);
        }
      })
    }, {rootMargin: `0px 0px -100px 0px`})
    

    targets.forEach((target, index) => {
      console.log("target", target)
      observer.observe(target, index);
    })



  
    
    // targets.forEach((target, index) => {
    //   console.log("target", target)
    //   target.animate({
    //     transform: ['translateY(1rem)', 'translateY(0)'],
    //     opacity: [0, 1],
    //     easing: 'ease-out',
    //   }, {
    //     duration: 500,
    //     fill: 'both',
    //     delay: 400 * .5 + index * 50,
    //   })
    // });

  }


}

window.customElements.define('stagger-grid', StaggerGrid);